export const comments_3249780 = {"data":{"data":[],"links":{}}}